import { createFileRoute } from '@tanstack/react-router';
import Alerts from '@src/pages/Alerts';

import { getLocalizedTitle } from '../title';

export const Route = createFileRoute('/_app/alerts')({
  head: () => ({
    meta: [{ title: getLocalizedTitle('alerts.page_title', 'Alerts') }],
  }),
  component: Alerts,
});
